/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

import { Component } from 'react';
import { connect } from 'react-redux';
import { isAuthorized } from 'shared/settings/auth';


class ErrorBoundary extends Component {

    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    componentDidMount() {
        // console.log = () => { };
        // console.warn = () => { };
        // console.error = () => { };
    }

    componentDidUpdate(prevProps) {
        if (prevProps.location.pathname !== this.props.location.pathname) {
            if (this.state.hasError) {
                window.location.reload();
            }
            this.setState({
                hasError: false
            });
        }
    }

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        if((error.message).includes('adsbygoogle')){
        }
        else{
            return { hasError: true };
        }
    }

    componentDidCatch(error, errorInfo) {
        // TO-DO Bugsnag
    }

    render() {
        if (this.state.hasError) {
            // fallback UI
            return <div className={`d-flex justify-content-center h-100 
            mt-3`}>
                <div className="large-screen-width" >
                    <div className="loader d-flex flex-column align-items-center justify-content-center h-100">
                        <img src={`${process.env.PUBLIC_URL}/static/images/sellerhomepageimage_1.png`}
                            alt="something-went-wrong"
                            style={{ width: "50%", height: "auto" }}
                        ></img>
                        <p style={{ fontSize: "3.0vh" }}>Oops, something went wrong...</p>
                        <p style={{ fontSize: "2.5vh" }}>{isAuthorized() ? <p>Try to refresh the page, or log out and log in again.</p> : <p>Try to refresh the page.</p>}</p>
                    </div>
                </div>
            </div>;
        }

        return this.props.children;
    }
}

export default connect(state => state)(ErrorBoundary);